import axios from "./api";

const Admin = {
  /**
   * Impersonate a business user
   * @param {number} businessUserId - The ID of the business user to impersonate
   * @returns {Promise} Axios promise with bearer token and user data
   */
  impersonate(businessUserId) {
    return axios.post("/admin/impersonate", {
      business_user_id: businessUserId,
    });
  },
};

export default Admin;



